<!-- projects -->
<div class="section section-projects container-fluid bg-white">

  <a class="section-anchor" name="section-projects"></a>

  <div class="container-section">

    <div class="row">

      <div class="col-12">

        <h2 class="alternate-heading text-center">
          <span class="text-primary">{{ 'View here' | translate}}</span><br />
          {{'all our projects' | translate}}
        </h2>

        <p class="text-center alternate-heading-subline">
          {{ 'Meet the Youngsters believes that land borders do not provide restrictions, but rather opportunities. Opportunities to orientate yourself just across the border and to participate in various projects / events. View them here!' | translate }}
        </p>

        <div class="grid grid-project">

          <div class="row flex-row">

            <div [routerLink]="'projects/' + (project.permalink ? project.permalink : project.id )" class="grid-item grid-item-project col-lg-3 col-md-4 col-sm-6 col-12 cursor-pointer" *ngFor="let project of projectService.homeData">

              <div class="grid-item-wrapper" [ngStyle]="{'background-image': 'url(' + project.imageUri + ')'}">
                <div class="grid-item-overlay"></div>

                <div class="grid-item-content">
                  <h3 class="grid-item-title">{{project.titleEn || project.title}}</h3>
                </div>

              </div>

            </div>

          </div>

          <div class="row row-button-more">

            <div class="col-12 text-center">

              <a routerLink="/projects" class="btn btn-primary btn-special">
                {{'All projects' | translate}}
              </a>

            </div>

          </div>


        </div>

      </div>

    </div>

  </div>

</div>
